/*
 * MDB shim for MDBListGroupItem
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Patient/pqQuoteSelector.jsx
 * - src/Seating/PresidentsClub/presidentsClubView.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 */

import MUIBox from "@mui/material/Box";

export default function MDBListGroupItem({ children, ...rest }) {
  return (
    <MUIBox component="li" {...rest}>
      {children}
    </MUIBox>
  );
}
